import { render, staticRenderFns } from "./MenuListSorter.vue?vue&type=template&id=255965ad&scoped=true&"
import script from "./MenuListSorter.vue?vue&type=script&lang=ts&"
export * from "./MenuListSorter.vue?vue&type=script&lang=ts&"
import style0 from "./MenuListSorter.vue?vue&type=style&index=0&id=255965ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255965ad",
  null
  
)

export default component.exports